export function user_rules(user_rules) {
  return {
    type: "@user_rules/user_rules",
    payload: {
      user_rules,
    },
  };
}
